import { FC, useRef, useState } from 'react';
import styled from 'styled-components';

import FilterButton from '@/components/FilterDropdown/FilterButton';
import FilterRadioButton from '@/components/FilterDropdown/FilterRadioButton';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import { scrollBarStyles } from '@/utils/theme';

const FitlerHolder = styled.div`
  position: relative;
`;

const DropDown = styled.div`
  background: ${({ theme }) => theme.colors.white};
  z-index: ${({ theme }) => theme.zIndex[2]};
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  border-radius: 4px;
  padding: 8px 4px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 55vh;
  overflow-y: auto;
  width: 284px;
  ${scrollBarStyles};
`;

interface Props {
  specialist?: number;
  editor?: number;
  setSpecialist: React.Dispatch<React.SetStateAction<number | undefined>>;
  setEditor: React.Dispatch<React.SetStateAction<number | undefined>>;
  users:
    | {
        specialists: {
          id: number;
          name: string;
        }[];
        editors: {
          id: number;
          name: string;
        }[];
      }
    | undefined;
}

const UsersFilters: FC<Props> = ({
  specialist,
  editor,
  setSpecialist,
  setEditor,
  users,
}) => {
  const [showSpecialist, setShowSpecialist] = useState(false);
  const [showEditor, setShowEditor] = useState(false);

  const specialistRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(specialistRef, () => setShowSpecialist(false));

  const editorRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(editorRef, () => setShowEditor(false));

  return (
    <>
      <FitlerHolder ref={editorRef}>
        <FilterButton
          onClick={() => setShowEditor((prev) => !prev)}
          isActive={showEditor}
          filterApplied={!!editor}
          text={'Editor'}
        />
        {!!showEditor && (
          <DropDown>
            <FilterRadioButton
              id={`editorRadio-0`}
              value={0}
              checked={!editor}
              setValue={() => {
                setEditor(undefined);
                setShowEditor(false);
              }}
              textType="caption"
            >
              All
            </FilterRadioButton>
            {users?.editors?.map((user) => (
              <FilterRadioButton
                key={user.id}
                id={`editorRadio-${user.id}`}
                value={user.id}
                checked={editor === user.id}
                setValue={() => {
                  setEditor(user.id);
                  setShowEditor(false);
                }}
                textType="caption"
              >
                {user.name}
              </FilterRadioButton>
            ))}
          </DropDown>
        )}
      </FitlerHolder>
      <FitlerHolder ref={specialistRef}>
        <FilterButton
          onClick={() => setShowSpecialist((prev) => !prev)}
          isActive={showSpecialist}
          filterApplied={!!specialist}
          text={'Specialist'}
        />
        {!!showSpecialist && (
          <DropDown>
            <FilterRadioButton
              id={`specialistRadio-0`}
              value={0}
              checked={!specialist}
              setValue={() => {
                setSpecialist(undefined);
                setShowSpecialist(false);
              }}
              textType="caption"
            >
              All
            </FilterRadioButton>
            {users?.specialists?.map((user) => (
              <FilterRadioButton
                key={user.id}
                id={`specialistRadio-${user.id}`}
                value={user.id}
                checked={specialist === user.id}
                setValue={() => {
                  setSpecialist(user.id);
                  setShowSpecialist(false);
                }}
                textType="caption"
              >
                {user.name}
              </FilterRadioButton>
            ))}
          </DropDown>
        )}
      </FitlerHolder>
    </>
  );
};

export default UsersFilters;
